import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { SharedModule } from '@shared/shared.module';
import { bookingStoreReducer } from '../store/booking.reducer';
import { BookingStoreEffects } from '../store/booking.effects';
import { BookingCountService } from './services/bookingCount.service';
import { BookingStoreService } from '../store/booking.store.service';
import { BookingTimePipe } from '../pipes/booking-time.pipe';
import { BookingResolver } from './resolvers/booking.resolver';
import { bookingsFeatureKey } from '../store/booking.state';

@NgModule({
  declarations: [BookingTimePipe],
  exports: [StoreModule, BookingTimePipe],
  imports: [
    StoreModule.forFeature(bookingsFeatureKey, bookingStoreReducer),
    EffectsModule.forFeature([BookingStoreEffects]),
    SharedModule
  ],
  providers: [BookingStoreEffects, BookingStoreService, BookingCountService, BookingResolver],
})
export class BookingClientModule {}
